import React from 'react';
import styled from 'styled-components';
import {
  IconPublic,
  Type,
  ButtonTertiary,
} from '@spotify-internal/encore-web-v6';
import {
  LanguageSelection,
  useLanguageSelectionDispatch,
} from '../../../../../features/src/i18n/components/LanguageSelection/index';
import { getDisplayName } from '../../../../../features/src/i18n/locales/index';
import {
  useLocale,
  useRtl,
  useT,
} from '../../../../../features/src/i18n/index';

const StyledButton = styled(ButtonTertiary)`
  opacity: 75%;
  &:hover {
    opacity: 100%;
  }
`;

const StyledButtonText = styled(Type)`
  margin-left: 2px;
`;

export const Language = () => {
  const locale = useLocale();
  const dispatch = useLanguageSelectionDispatch();
  const t = useT();
  const rtl = useRtl();
  return (
    <LanguageSelection>
      <StyledButton
        onClick={() => dispatch({ type: 'open' })}
        aria-label={t(
          'FRODOR_change_language_label',
          'Change language',
          'Allow user to change the langauge displayed on the screen',
        )}
        data-testid="language-selection-trigger"
        iconLeading={IconPublic}
        dir={rtl ? 'rtl' : 'ltr'}
        buttonSize="sm"
        semanticColor="textBase"
        condensedAll
      >
        <StyledButtonText variant="mestoBold">
          {getDisplayName(locale)}
        </StyledButtonText>
      </StyledButton>
    </LanguageSelection>
  );
};
